<template>
    <a :href="downloadLink" class="link-download" target="_blank">{{ text }}</a>
</template>

<script>

const pdfLinks = {
    privacy_1: "/public/docs/privacy_1_sim.pdf",
    privacy_axa: "/public/docs/privacy_axa.pdf",
    privacy_2: "/public/docs/privacy_2_sim.pdf",
    privacy_axa_2: "/public/docs/privacy_axa.pdf",
    terms_and_conditions: "/public/docs/ins4models-terms_and_conditions.pdf",
}
export default {
    props: {
        what: String,
        text: {
            type: String,
            default: 'here'
        }
    },
    computed:{
        downloadLink: function(){
            // 2022
            if(this.what == 'terms_and_conditions'){
                let href = pdfLinks[this.what];
                const year = new Date().getFullYear();
                return href.replace('.pdf', `_${year}.pdf`);
            } else {
                return pdfLinks[this.what];
            }
            
        }
    }
}
</script>